import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { FaAngleUp } from 'react-icons/fa';
import {TmoButtons} from '@tmobile/tmo-bps-syncup-web-component-lib'

import style from './BackToTop.module.css';

const BackToTop = ({ testId, ...rest }) => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [visibleTopBtn, setvisibleTopBtn] = useState(false);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowHeight(window.innerHeight);
    };

    const handleWindowScroll = () => {
      window.document.body.offsetHeight > windowHeight * 4
        ? setShowTopBtn(true)
        : setShowTopBtn(false);
      window.scrollY > windowHeight * 2
        ? setvisibleTopBtn(true)
        : setvisibleTopBtn(false);
    };

    window.addEventListener('resize', handleWindowResize);
    window.addEventListener('scroll', handleWindowScroll);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
      window.removeEventListener('scroll', handleWindowScroll);
    };
  }, [windowHeight]);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    showTopBtn && (
      <TmoButtons className={style.back_top_wrapper} data-testid={testId} aria-label="Back to Top">
        {visibleTopBtn && (
          <FaAngleUp
            title="Back to Top"
            className={classNames(style.icon_position, style.icon_style)}
            onClick={goToTop}
            {...rest}
          />
        )}
      </TmoButtons>
    )
  );
};
export default BackToTop;
